import { Box, Typography, useTheme } from "@mui/material"
import Grid from "@mui/material/Grid"
import TextField from "@mui/material/TextField"
import Button from "components/Button"
import { Formik } from "formik"
import { nanoid } from "nanoid"
import { useTranslation } from "react-i18next"
import { StyledListItemText } from "shared/styled/General"

const ViolationDrivingTypesAdd = ({ onSubmit }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const initialValues = {
    name: "",
    id: 0
  }

  const handleSubmit = async (values, { resetForm }) => {
    const violationDriverTypesToSave = {
      ...values,
      listId: nanoid()
    }
    resetForm()
    onSubmit(violationDriverTypesToSave)
  }

  return (
    <Formik onSubmit={handleSubmit} initialValues={initialValues} enableReinitialize={true}>
      {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
        <form onSubmit={handleSubmit} noValidate>
          <Grid container spacing={2} pb={2}>
            <Grid item xs={12}>
              <Typography>
                {t(
                  "violation.companyspecific_categories",
                  'Company-specific categories for "type of driving"'
                )}
              </Typography>
            </Grid>
          </Grid>
          <Box bgcolor={theme.palette.grey[100]} sx={{ borderRadius: "6px" }} padding={3} width="100%">
            <Box>
              <StyledListItemText
                primary={t("violation.select_driving_type", "Select driving type")}
                style={{ paddingBottom: "8px", margin: 0 }}
              />
            </Box>
            <Grid
              container
              gap={2}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              flexWrap="nowrap"
              flexDirection="row">
              <Grid item xs={10}>
                <TextField
                  sx={{ width: "100%", background: theme.palette.background.paper }}
                  autoComplete="off"
                  fullWidth
                  id="name"
                  placeholder={t("violation.driving_type", "Type of driving")}
                  value={values.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  variant="outlined"
                />
              </Grid>
              <Button color="primary" type="button" variant="outlined" size="small" onClick={handleSubmit}>
                {t("global.add", "Add")}
              </Button>
            </Grid>
          </Box>
        </form>
      )}
    </Formik>
  )
}
export default ViolationDrivingTypesAdd
